import "../../../css/IconStyle.css";
import { GrMapLocation } from "react-icons/gr";

const GeoManagerIcon = () => {
  return <GrMapLocation size={22} className="sidebar-icon" />;
};
export default GeoManagerIcon;
